import React, { useEffect, useState } from 'react';

import 'react-loading-skeleton/dist/skeleton.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-slick';
import 'react-toastify/dist/ReactToastify.css';
import 'rc-checkbox/assets/index.css';
import '@bepro-travel/fe.shared/dist/styles.css';
import './styles/ophir-details.scss';
import './styles/ophir-itinerary.scss';
import './styles/ophir.scss';
import './styles/reset.scss';
import './styles/variables.scss';

import {
  PageFooter,
  PageHeader,
  SharedConfigContext,
  SiteConfig,
  User,
  auth,
} from '@bepro-travel/fe.shared';
import { blobUrl, cdnUrl, imgBg, reCaptchaKey } from './constants';
import Router from './router';
import { BrowserRouter } from 'react-router-dom';
import { configureAxios, configureStorage } from './config';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Header from './components/Header';
import { MainContext } from './contexts/MainContext';
import { i18nconfig } from './utils';
import { ToastContainer } from 'react-toastify';
import { hotjar } from 'react-hotjar';
import OphirSearchBox from './components/OphirSearchBox';
import Footer from './components/Footer';

export const sharedConfig = {
  cdnUrl,
  footer: undefined,
  setFooter: () => { },
  header: undefined,
  setHeader: () => { },
  siteConfig: undefined,
  setSiteConfig: () => { },
  setLanguage: () => { },
  language: 'ru',
  imgIs: '',
  imgUs: '',
  imgBg: '',
  imgLogo: require('./assets/img/logo.png'),
  imgPaymentLoader: '',
  proposal: {
    hotels: [],
    flights: [],
    ilPackages: [],
    dynamic: [],
    transfers: [],
  },
  setProposal: () => { },
};

function App() {
  const [header, setHeader] = useState<PageHeader | undefined>();
  const [footer, setFooter] = useState<PageFooter | undefined>();
  const [siteConfig, setSiteConfig] = useState<SiteConfig | undefined>(undefined);
  const [isAppReady, setIsAppReady] = useState(false);
  const [user, setUser] = useState<User>();

  useEffect(() => {
    (async () => {
      configureStorage();
      await configureAxios();
      const user = await auth.getUserToken();
      i18nconfig();
      setUser(user);

      setIsAppReady(true);

      hotjar.initialize({ id: 6450771, sv: 6 });

      console.log('hotjar initialized', hotjar.initialized(), 6450771);
    })();
  }, []); // eslint-disable-line

  return (
    <BrowserRouter>
      {isAppReady && (
        <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
          <MainContext.Provider
            value={{
              header,
              footer,
              siteConfig,
              setFooter,
              setHeader,
              setSiteConfig,
              user,
              setUser,
            }}
          >
            <SharedConfigContext.Provider
              value={{
                ...sharedConfig,
                footer,
                setFooter,
                header,
                setHeader,
                siteConfig,
                setSiteConfig,
                defaultMultiSearchConfig: '',
                SearchBox: OphirSearchBox,
                soldOutImg: require('./assets/img/sold_out.png'),
                user,
                setUser,
                userSiteConfig: {},
                setUserSiteConfig: () => { },
                defaultUserSiteConfig: {},
              }}
            >
              <Header notOpenTabWithChildren={true} />
              <Router />
              <Footer />
            </SharedConfigContext.Provider>
          </MainContext.Provider>
        </GoogleReCaptchaProvider>
      )}
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
